<template>
  <v-card class="px-5 py-5">
    <v-form ref="form" lazy-validation>
      <v-row>
        <v-col>
          <v-text-field :rules="number" hide-details="auto" label="员工数量" v-model="form.workers" filled rounded  dense></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field :rules="number" hide-details="auto" label="知识产权数量" v-model="form.patentNumber" filled rounded  dense></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-select-search
          filled rounded  dense
          hide-details
          label="年份选择"
          :data='yearItems'
          item-text="label"
          item-value="value"
          :rules="required"
          v-model='form.createYear'>
        </v-select-search>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-select
            :items="seniorityItems"
            label="企业资质"
            v-model="form.seniorityIdList"
            filled rounded  dense
            multiple
            item-text='name'
            item-value="id"
            @change="seniorityChange"
          ></v-select>
        </v-col>
      </v-row>

    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text class="text--disabled" @click='item.show = false'>
        关闭
      </v-btn>
      <v-btn color="primary" rounded :loading="loading" @click='save'>
        保存
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { getByPids } from '@/api/system/dictionary.js'
  import { save } from '@/api/customer/detail.js'
  import { selectData } from '@/utils/tool.js'
  import VSelectSearch from '@/components/select/v-select-search.vue'

  export default {
    name: 'CustomerDetailAdd',
    components: {
      VSelectSearch
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          data: null
        })
      },
      show: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      show (n) {
        if (n) {
          if (this.item.data.detail) {
            this.form = JSON.parse(JSON.stringify(this.item.data.detail))
          }
        } else {
          this.form = JSON.parse(JSON.stringify(this.defForm))
        }
      }
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        number: [
          value => /^[0-99]+.?[0-99]*$/.test(value) || '必须输入数字',
        ],
        seniorityItems: [],
        yearItems: selectData(20),
        form: {
          id: '',
          workers: '',
          createYear: '',
          customerId: '',
          patentNumber: '',
          seniorityIds: '',
          seniorityIdList: [],
          seniorityStr: ''
        },
        defForm: {
          id: '',
          workers: 0,
          createYear: '',
          customerId: '',
          patentNumber: 0,
          seniorityIds: '',
          seniorityIdList: [],
          seniorityStr: ''
        }
      }
    },
    methods: {
      save () {
        this.buildFrom()
        if (this.$refs.form.validate()) {
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      buildFrom () {
        this.form.seniorityIds = JSON.stringify(this.form.seniorityIdList)
        this.form.customerId = this.item.data.id
      },
      seniorityChange (arr) {
        const this_ = this
        this_.form.seniorityStr = ''
        this.seniorityItems.forEach(item => {
          arr.forEach(id => {
            if (item.id === id) {
              this_.form.seniorityStr += `${item.name},`
            }
          })
        })
        this_.form.seniorityStr = this_.form.seniorityStr.substring(0, this_.form.seniorityStr.lastIndexOf(','))
      },
      getTypes () {
        getByPids(
          {
            pids: [
              this.$constants.customerSeniorityPid
            ]
          }
        ).then(res => {
          if (res.status === 200) {
           const this_ = this
           res.data.forEach((result) => {
              if (this_.$constants.customerSeniorityPid === result.id) {
                this_.seniorityItems = result.data
             }
           })
          }
        })
      }
    },
    created() {
      this.getTypes()
    }
  }
</script>

<style lang="sass" scoped>
</style>
